import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ClientManagementPanel = ({ clients, onViewClient, onMessageClient }) => {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredClients = clients?.filter(client =>
    client?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const getProgressColor = (progress) => {
    if (progress >= 75) return 'bg-success';
    if (progress >= 50) return 'bg-warning';
    return 'bg-error';
  };

  return (
    <div className="card">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-accent/10 flex items-center justify-center">
            <Icon name="Users" size={24} color="var(--color-accent)" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">My Clients</h2>
            <p className="text-sm text-muted-foreground">{clients?.length} active clients</p>
          </div>
        </div>
        <Button variant="default" iconName="UserPlus" iconPosition="left">
          Add Client
        </Button>
      </div>
      <div className="mb-4">
        <Input
          type="search"
          placeholder="Search clients..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e?.target?.value)}
          className="w-full"
        />
      </div>
      <div className="space-y-3 max-h-[500px] overflow-y-auto custom-scrollbar">
        {filteredClients?.map((client) => (
          <div
            key={client?.id}
            className="flex flex-col sm:flex-row sm:items-center gap-4 p-4 rounded-lg border border-border hover:border-primary/50 transition-all duration-250 bg-card"
          >
            <div className="flex items-center gap-4 flex-1 min-w-0">
              <div className="relative flex-shrink-0">
                <Image
                  src={client?.avatar}
                  alt={client?.avatarAlt}
                  className="w-14 h-14 rounded-full object-cover"
                />
                {client?.isOnline && (
                  <div className="absolute bottom-0 right-0 w-4 h-4 bg-success rounded-full border-2 border-card"></div>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-base font-medium text-foreground truncate">{client?.name}</h3>
                <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground mt-1">
                  <span className="flex items-center gap-1">
                    <Icon name="Target" size={14} />
                    {client?.goal}
                  </span>
                  <span className="flex items-center gap-1">
                    <Icon name="Calendar" size={14} />
                    {client?.nextSession}
                  </span>
                </div>
                <div className="mt-2">
                  <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
                    <span>Program Progress</span>
                    <span className="font-medium">{client?.progress}%</span>
                  </div>
                  <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                    <div
                      className={`h-full ${getProgressColor(client?.progress)} transition-all duration-500`}
                      style={{ width: `${client?.progress}%` }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2 flex-shrink-0">
              <Button
                variant="outline"
                size="sm"
                iconName="MessageSquare"
                onClick={() => onMessageClient(client?.id)}
              >
                Message
              </Button>
              <Button
                variant="default"
                size="sm"
                iconName="Eye"
                onClick={() => onViewClient(client?.id)}
              >
                View
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientManagementPanel;